import React, { useCallback, useState, useEffect, useMemo } from "react";
import { Dimensions, StyleSheet, View, Text, ScrollView } from "react-native";
import { useHistory } from "react-router-dom";
import Row from "~/layouts/Row";
import palette from "~/styles/palette";
import Col from "~/layouts/Col";

import useTwilio from "~/hooks/useTwilio";
import IconButton from "~/components/Buttons/IconButton";
import SolidButton from "~/components/Buttons/SolidButton";

export default function IncomingCallModal() {
  const history = useHistory();
  const isFullScreen = Dimensions.get("window").width < 960;
  const { activeCall, callState, startCall, endCall } = useTwilio();

  const visible = useMemo(
    () => (history.location.pathname !== '/calls' && callState?.invited && !callState.success && activeCall ),
    [callState, activeCall, history]
  );

  const headerText = useMemo(() => {
    if (
      visible &&
      activeCall?.customParameters &&
      activeCall?.customParameters.has("participantName")
    ) {
      return activeCall?.customParameters?.get('participantName');
    }

    return "";
  }, [activeCall, visible]);

  const onAcceptIncomingCall = () => {
    if (callState.invited) {
      startCall();
    }
  };

  const onRejectIncomingCall = () => {
    endCall();
  };

  if (!visible) return null;

  return (
    <View style={[styles.modal_overlay]}>
      <View
        style={[styles.modal_container, { width: isFullScreen ? "100%" : 600 }]}
      >
        <Text style={[styles.modal__header_title_text]}>{headerText}</Text>
        <Text style={[styles.modal__header_shadow_text]}>
          Incoming Phone Call
        </Text>

        <Row mt={32} mb={32} center>
          <Col rightCenter pr={16}>
            <IconButton
              iconName="phone"
              iconColor={palette.white}
              color={palette.danger}
              iconSize={32}
              style={{
                transform: [{ rotateZ: "135deg" }],
              }}
              height={80}
              width={80}
              onPress={onRejectIncomingCall}
            />
          </Col>

          <Col leftCenter pl={16}>
            <IconButton
              iconName="phone"
              iconColor={palette.white}
              color={palette.success}
              iconSize={32}
              height={80}
              width={80}
              onPress={onAcceptIncomingCall}
            />
          </Col>
        </Row>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  modal__header: {
    height: 75,
    borderBottomColor: palette.light_grey,
    borderBottomWidth: 1,
    backgroundColor: palette.primary,
    justifyContent: "center",
  },
  modal__body: {
    paddingHorizontal: 16,
    flex: 1,
  },
  modal__footer: {
    paddingHorizontal: 16,
    marginBottom: 8,
  },
  modal__header_title_text: {
    color: palette.white,
    fontSize: 32,
    fontWeight: "600",
    fontFamily: "acumin-pro, san-serif",
    textAlign: 'center',
  },
  modal__header_subtitle_text: {
    color: palette.white,
    fontSize: 20,
    fontWeight: "600",
    fontFamily: "acumin-pro, san-serif",
    textAlign: 'center',
  },
  modal__header_shadow_text: {
    color: palette.white,
    opacity: 0.6,
    fontSize: 18,
    fontWeight: "600",
    fontFamily: "acumin-pro, san-serif",
    textAlign: 'center',
  },
  modal_overlay: {
    backgroundColor: "rgba(45, 62, 80, 0.79)",
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
    transitionProperty: "none",
    transitionDelay: "0ms",
    transitionDuration: "100ms",
  },
  modal_container: {
    borderRadius: 8,
    justifyContent: 'center',
    backgroundColor: palette.primary,
    paddingVertical: 16,
    position: "absolute",
    minWidth: "300px",
    maxWidth: "100%",

    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    zIndex: 1040,
    shadowColor: "#000",
    shadowOffset: {
      width: -5,
      height: 0,
    },
    shadowOpacity: 0.12,
    shadowRadius: 9,
    elevation: 4,
    transitionProperty: "right",
    transitionDelay: "100ms",
    transitionDuration: "200ms",
  },
});
